export type ClassroomContentKind = 'trail' | 'course'

export type MenuGroupKind = 'milestone' | 'course'

export type MaterialType =
  | 'video'
  | 'audio'
  | 'pdf'
  | 'document'
  | 'scorm'
  | 'link'
  | 'image'
  | 'carousel'
  | 'test'

export type MenuItemStatus = 'completed' | 'in-progress' | 'pending' | 'locked'

export interface MenuMaterial {
  id: string
  title: string
  type: MaterialType
  status: MenuItemStatus
  progress?: number
  duration?: string
  to?: string
}

export interface MenuGroup {
  id: string
  title: string
  kind: MenuGroupKind
  progress?: number
  locked?: boolean
  children: MenuNode[]
}

export type MenuNode = MenuGroup | MenuMaterial

export interface ClassroomMenuContent {
  id: string
  title: string
  kind: ClassroomContentKind
  progress: number
  children: MenuNode[]
}

export const isMenuGroup = (node: MenuNode): node is MenuGroup => 'children' in node
